export default {"src":"/_next/static/media/Ledger.26b94fed.svg","height":32,"width":88,"blurWidth":0,"blurHeight":0};